import { object, string, array, number, mixed } from "yup"

export const tagsSchema = object({
  tags: array().of(
    mixed({
      id: number().nullable(),
      name: string().required("required")
    }).transform((value) => value.name)
  )
})
